import { Component, Input, Output, TemplateRef, OnInit, SimpleChanges, EventEmitter} from '@angular/core';
import { IPropertyRentTermModel } from '../../shared/models/PropertyRentTermModel';
import { PropertyListingService } from '../../shared/providers/property-listing.service';
import { AuthenticationService } from '../../shared/auth/authentication.service'
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ValidationService } from '../../shared/providers/validation.service';
import { UserRole } from '../../shared/enum/enum';

@Component({
  selector: 'app-rent-term-table',
    templateUrl: './rent-term-table.component.html',      
})

export class RentTermTableComponent implements OnInit {    
    @Input() propertyId: number;
    @Input() rentTerms: IPropertyRentTermModel;
    @Input() rentTermsAutoCalc: boolean;    
    @Input() InitialLoad: boolean;
    @Input() PropertyRentTerms = [] as IPropertyRentTermModel[];
    @Input() IsEditAllowed: boolean;
    @Input() IsDataEntryProperty = false as boolean;
    @Output() updateLoadStatus = new EventEmitter();
    @Output() rentTerm = new EventEmitter();
        
    PropertyRentTerm: IPropertyRentTermModel[];
    modalRef: BsModalRef;
    currentRentTermDetails = {} as IPropertyRentTermModel;   
    rentTermDiffMonth = {} as IPropertyRentTermModel;
    rentTermToDelete: number;  
    loggedUserDetails: any;
    currentRentTerm: number | null;
    optionsCount: number;

    constructor(private _validationService: ValidationService, private _propertyService: PropertyListingService, private authService: AuthenticationService, private modalService: BsModalService) { }
    ngOnInit() {
        if (this.InitialLoad && this.propertyId > 0) {
            this.loadRentTerm()
        }
    }
    loadRentTerm(propertyId?: number) {        
        if (propertyId) {
            this.propertyId = propertyId;
        }
        if (this.propertyId > 0)
            {
            if (this.IsDataEntryProperty) {
                this._propertyService.GetDataEntryPropertyRentTermTable(this.propertyId).subscribe(res => {
                    if (res.length > 0) {
                        for (let i = 0; i < res.length; i++) {
                            res[i].LeaseStartDate = this._validationService.convertUTCDateToLocalDate(res[i].LeaseStartDate);
                            res[i].LeaseEndDate = this._validationService.convertUTCDateToLocalDate(res[i].LeaseEndDate);
                        }

                        this.PropertyRentTerm = res;
                    }
                    else if (this.rentTermsAutoCalc) {
                        this.calculateRentTerm();
                    }

                    this.updateLoadStatus.emit(false);
                    this.saveRentTermDetails();                    
                });
            }
            else {
                this._propertyService.GetPropertyRentTermTable(this.propertyId).subscribe(res => {
                    if (res.length > 0) {
                        for (let i = 0; i < res.length; i++) {
                            res[i].LeaseStartDate = this._validationService.convertUTCDateToLocalDate(res[i].LeaseStartDate);
                            res[i].LeaseEndDate = this._validationService.convertUTCDateToLocalDate(res[i].LeaseEndDate);
                        }

                        this.PropertyRentTerm = res;
                    }
                    else if (this.rentTermsAutoCalc) {
                        this.calculateRentTerm();
                    }

                    this.updateLoadStatus.emit(false);
                    this.saveRentTermDetails();                       
                });
            }
        }
    }

    openEditRentTermTable(template: TemplateRef<any>, classes, item, index) {        
        this.currentRentTermDetails.Increase = item.Increase != undefined ? item.Increase : 0;
        this.currentRentTermDetails.LeaseEndDate = new Date(item.LeaseEndDate);
        this.currentRentTermDetails.LeaseStartDate = new Date(item.LeaseStartDate);
        this.currentRentTermDetails.NetOperatingIncome = item.NetOperatingIncome;
        this.currentRentTermDetails.Years = item.Years;
        this.currentRentTermDetails.Id = index;
        this.currentRentTermDetails.OptionNumber = item.OptionNumber;
        this.currentRentTermDetails.IsOptional = item.IsOptional;
        this.currentRentTermDetails.IsIncreaseAutoCalc = item.IsIncreaseAutoCalc == null ? true : item.IsIncreaseAutoCalc;
        this.currentRentTermDetails.LeaseCommencementDate = this.rentTerms.LeaseCommencementDate;
        this.currentRentTermDetails.LeaseExpiration = this.rentTerms.LeaseExpiration;
        this.modalRef = this.modalService.show(template, { class: classes });
    }  
    closeModal() {
        this.modalRef.hide();        
    } 
    saveRentTerm(SaveRentTermDetails: IPropertyRentTermModel) {
        if (this.PropertyRentTerm.length <= SaveRentTermDetails.Id) {
            this.PropertyRentTerm.push(SaveRentTermDetails);
        }
        else {
            this.PropertyRentTerm[SaveRentTermDetails.Id] = SaveRentTermDetails;
        }

        this.modalRef.hide();
        this.saveRentTermDetails();   
    }

    saveRentTermDetails() {
        this.PropertyRentTerm.forEach(item => {
            item.NetOperatingIncome = item.NetOperatingIncome;
        });
        this.rentTerm.emit(this.PropertyRentTerm);
    }

    calculateRentTerm() {        
        //if (this.rentTermsAutoCalc) {
            this.PropertyRentTerm = [];
            let index: number;
            let prevNetOperatingIncome: number
            let Increase = 0 as number;
            let LeaseCommencementDate: Date
            let LeaseExpiration: Date | any;
            let optionNumber: number;
            let optionLength: number;
            let isOptional = false as boolean;
            let rentEscalationPeriod: number;
            let items: IPropertyRentTermModel[] = [];

            if (this.rentTerms != null) {
                
                try {
                    prevNetOperatingIncome = +this.rentTerms.NetOperatingIncome;
                    LeaseCommencementDate = this.rentTerms.LeaseCommencementDate;
                    LeaseExpiration = this.rentTerms.LeaseExpiration;
                    optionNumber = +this.rentTerms.OptionNumber;
                    optionLength = +this.rentTerms.OptionLength;
                    rentEscalationPeriod = +this.rentTerms.RentEscalationPeriod

                    let firstOption: boolean;
                    let previous = 0;
                    let OptionNumber = 0;
                    let totalLeaseYears = LeaseExpiration.getFullYear() - this.rentTerms.LeaseCommencementDate.getFullYear() + (optionNumber * +optionLength);
                   // totalLeaseYears = totalLeaseYears == 0 ? 1 : totalLeaseYears;
                    let leaseYears = LeaseExpiration.getFullYear() - this.rentTerms.LeaseCommencementDate.getFullYear();
                    let items = [] as IPropertyRentTermModel[];
                    let monthNumber;
                    let leasEndDate = this._validationService.YearAdd(LeaseExpiration, (optionNumber * +optionLength));
                    for (let k = 0; k <= totalLeaseYears; k++) {
                        if (k > 0 && k  % rentEscalationPeriod == 0) {
                            prevNetOperatingIncome = (this.rentTerms.RentEscalationPercentage * prevNetOperatingIncome / 100) + prevNetOperatingIncome;
                            Increase = this.rentTerms.RentEscalationPercentage;
                        }
                        //if (OptionNumber > 0 && (k - leaseYears != 0) && (k - leaseYears) % optionLength == 0) {
                        //    OptionNumber = OptionNumber + 1;
                        //}
                
                        for (let i = 0; i < 12; i++) {
                            if (leasEndDate >= this._validationService.MonthAdd(LeaseCommencementDate, 1) || (totalLeaseYears == 0 && i == 0)) {
                                if (OptionNumber > 0 && (k - leaseYears != 0) && (k - leaseYears) % optionLength == 0 && monthNumber == i) {
                                    OptionNumber = OptionNumber + 1;
                                }

                                let monthlyitems = {} as IPropertyRentTermModel;
                                monthlyitems.Years = (k + 1).toString();// + '_' + OptionNumber;
                                monthlyitems.Id = i;
                                monthlyitems.NetOperatingIncome = prevNetOperatingIncome / 12; //monthlyNetOperatingIncome
                                monthlyitems.Increase = Increase;
                                monthlyitems.LeaseStartDate = LeaseCommencementDate
                                monthlyitems.LeaseEndDate = this._validationService.MonthAdd(LeaseCommencementDate, 1);
                                monthlyitems.IsOptional = OptionNumber > 0;
                                monthlyitems.OptionNumber = OptionNumber;

                                items.push(monthlyitems)
                                    //  this.PropertyRentTerm.push(monthlyitems);
                                LeaseCommencementDate = monthlyitems.LeaseEndDate;

                                if (LeaseCommencementDate >= LeaseExpiration && OptionNumber == 0) {
                                    monthNumber = i == 11 ? 0 : i + 1; // from nxt month onwards
                                    OptionNumber = 1;
                                    //firstOption = true;                      
                                    if (optionLength * optionNumber == 0) {
                                        i = 11;
                                    }
                                }
                            }
                        }

                    }
                   
                    OptionNumber = 0;
                    Increase = 0;
                    let total = 0;
                    let yearCount = 0
                    var previousitem = items[0] as IPropertyRentTermModel;
                    let finalList = [] as IPropertyRentTermModel[];
                    let date = new Date();
                    for (let index = 0; index < items.length; index ++) {
                        yearCount = yearCount + 1;
                        total = total + items[index].NetOperatingIncome;

                        Increase = Increase + items[index].Increase;
                        
                        if (index == items.length - 1 || (previousitem.OptionNumber != items[index + 1].OptionNumber || (previousitem.OptionNumber == 0 && previousitem.NetOperatingIncome != items[index + 1].NetOperatingIncome))) { //
                            var currentitem = {} as IPropertyRentTermModel;
                            var Years = previousitem.Years + ' - ' + items[index].Years //+ '_' + items[index].OptionNumber;
                            var LeaseEndDate = items[index].LeaseEndDate;
                            var LeaseStartDate = previousitem.LeaseStartDate;
                            var IsOptional = previousitem.IsOptional;
                            var OptionNumbers = previousitem.OptionNumber;
                            var NetOperatingIncome = total / yearCount * 12;
                          var previousNetOperatingIncome = this.PropertyRentTerm.length == 0 ? NetOperatingIncome : this.PropertyRentTerm[this.PropertyRentTerm.length - 1].NetOperatingIncome;
                          let a = parseFloat((NetOperatingIncome - previousNetOperatingIncome).toFixed(10));
                          var b = a / previousNetOperatingIncome;
                          var c = b * 100;
                          var Increases = c;
                            /*var Increases = this.PropertyRentTerm.length == 0 ? 0 : (((NetOperatingIncome - previousNetOperatingIncome) / previousNetOperatingIncome) * 100);*/

                            currentitem.Years = Years;
                            currentitem.LeaseEndDate = this._validationService.DateAdd(LeaseEndDate, -1);
                            currentitem.LeaseStartDate = LeaseStartDate;
                            currentitem.IsOptional = IsOptional;
                            currentitem.OptionNumber = OptionNumbers;
                            currentitem.NetOperatingIncome = NetOperatingIncome;
                          currentitem.Increase = Increases;
                          currentitem.PreviousNetOperatingIncome = previousNetOperatingIncome;

                            total = 0;
                            yearCount = 0;
                            Increase = 0;

                            this.PropertyRentTerm.push(currentitem);
                            previousitem = {} as IPropertyRentTermModel;
                            if (index < items.length - 1) {
                                previousitem = items[index + 1];
                            }

                        }
                        else if (items.length == 1) {
                            var currentitem = {} as IPropertyRentTermModel;
                            var Years = previousitem.Years + ' - ' + items[index].Years //+ '_' + items[index].OptionNumber;
                            var LeaseEndDate = items[index].LeaseEndDate;
                            var LeaseStartDate = previousitem.LeaseStartDate;
                            var IsOptional = previousitem.IsOptional;
                            var OptionNumbers = previousitem.OptionNumber;
                            var NetOperatingIncome = total / yearCount * 12;
                            var Increases = previousitem.Increase;

                            currentitem.Years = Years;
                            currentitem.LeaseEndDate = this._validationService.DateAdd(LeaseEndDate, -1);
                            currentitem.LeaseStartDate = LeaseStartDate;
                            currentitem.IsOptional = IsOptional;
                            currentitem.OptionNumber = OptionNumbers;
                            currentitem.NetOperatingIncome = NetOperatingIncome;
                            currentitem.Increase = Increases;
                            currentitem.PreviousNetOperatingIncome = previousNetOperatingIncome;

                            total = 0;
                            yearCount = 0;
                            Increase = 0;

                           this.PropertyRentTerm.push(currentitem);
                        }    
               
                    }                                 
                }
                catch (ex) {
                    //console.log(ex);
                }
                this.saveRentTermDetails();
            }
        //}
    }

    deleteRentTerm($event) {
        
        this.PropertyRentTerm.splice(this.rentTermToDelete, 1);
        this.saveRentTermDetails();
    }

    openModal(template: TemplateRef<any>, classes: any, index: number) {
        this.rentTermToDelete = index;
        this.modalRef = this.modalService.show(template, { class: classes });
    }
    openAutoCalcRentTermModal(template: TemplateRef<any>, classes: any, index: number) {
        this.rentTermToDelete = index;
        this.modalRef = this.modalService.show(template, { class: classes });
    }

    addRentTerm(template: TemplateRef<any>, classes) {
        this.currentRentTermDetails = {} as IPropertyRentTermModel;
        this.currentRentTermDetails.Id = this.PropertyRentTerm != undefined ? this.PropertyRentTerm.length : 0;
        this.currentRentTermDetails.LeaseCommencementDate = this.rentTerms.LeaseCommencementDate;
        this.currentRentTermDetails.LeaseExpiration = this.rentTerms.LeaseExpiration;
        this.currentRentTermDetails.IsIncreaseAutoCalc = true;
        this.modalRef = this.modalService.show(template, { class: classes });
        
    }

    getColor(index) {
        const colors = [' #6596D6 ', ' #67A7FA ', ' #1967CB ', ' #0D77FF ', ' #004298 ', ' #285CA1 ', ' #55759E ', ' #4788DC ', ' #5167EA ', ' #2B44D8 ', ' #7582CF ', ' #4354B9 ', ' #0F24A4 ', ' #1458E2 ', ' #3562BF ', ' #305297 ', ' #333286 ', ' #98C7FF ', ' #4886D8 ', ' #2C99D7 ', ' #157BB5 ', ' #0C6699 ', ' #49A1D3 ', ' #62BFF3 ', ' #51B5D1 ', ' #6186D3 ', ' #33C5DF ', ' #21A5BC ', ' #277583 ', ' #274183 ', ' #21459E ', ' #4674E6 ', ' #3355AA ', ' #596C9C ', ' #503C8D ', ' #6042BE ', ' #906CFF ', ' #B08CC8 ', ' #A374AE ', ' #B4658E ', ' #CA62DF ', ' #A264D9 ', ' #90B36C ', ' #6C963D ', ' #6AB16A ', ' #75D285 ', ' #B3BB66 ', ' #C77272 ', ' #D75555 ', ' #A34646 ']
        return colors[index];
    }

    parentCallAddRentTable() {                
        $('#hdnAddRentTermTable').click();
    }

    showRentTermOptions(index) {
        var status = false;
        var count = 0; 
        if (index == 0) {
            this.optionsCount = 0;
        }
        this.PropertyRentTerm.forEach(res => {
            if (res.IsOptional) {
                if (count == index && this.optionsCount == 0) {
                    status = true
                    this.optionsCount = 1
                }
            }
            count++;
        })
        return status;
    }

    showCurrentDate(currentitem) {
        let date = new Date();
        var status = false;
        if (currentitem.LeaseStartDate <= date && currentitem.LeaseEndDate >= date) {
            status = true;
        }

        return status;
    }
}

